namespace appn.views.taskTemplates.details {

    class InitArgs {
        latLonUser: string = appn.emptyString;
        firstToClaimId: string = appn.emptyString;
        allToCompleteId: string = appn.emptyString;
        modelCanSave: boolean = false;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;

        appn.tasks.init(_initArgs.firstToClaimId, _initArgs.allToCompleteId, true);
        appn.tasks.initAddressMap({
            completeAtLot: 'Template_Task_CompleteAtLot',
            completeAtText: 'Template_Task_CompleteAtText',
            completeAtCountry: 'Template_Task_CompleteAtCountry',
            completeAtLat: 'Template_Task_CompleteAtLat',
            completeAtLon: 'Template_Task_CompleteAtLon'
        }, _initArgs.latLonUser, _initArgs.modelCanSave);

        if ($('nav .navbar-nav-right button[value*="Trash"]').length > 0)
            appn.trash.addTrashMessage($('nav .navbar-nav-right button[value*="Trash"]'), '#Template_Task_Name', undefined, undefined, false);
    }
}
